// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modalContent___GAG4\\+{font-size:16px;line-height:24px;padding:24px 0 48px}.containerClass___jfvQW{width:464px}\n", "",{"version":3,"sources":["webpack://./src/routes/Reports/routes/NewReport/components/ReportNotSavedWarning/index.css"],"names":[],"mappings":"AAAA,uBACI,cAAA,CACA,gBAAA,CAFJ,mBAAA,CAMA,wBACI,WAAA","sourcesContent":[".modalContent {\n    font-size: 16px;\n    line-height: 24px;\n    padding: 24px 0 48px 0;\n}\n\n.containerClass {\n    width: 464px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": "modalContent___GAG4+",
	"containerClass": "containerClass___jfvQW"
};
export default ___CSS_LOADER_EXPORT___;
